/**
 * @generated SignedSource<<9edc49d2e77219055ffa78462eb0c90b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteChannelPayload",
    "kind": "LinkedField",
    "name": "deleteChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedJoinedChannelId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteChannelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteChannelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5a5cf801b6d5c708fe999d4663d28334",
    "id": null,
    "metadata": {},
    "name": "DeleteChannelMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteChannelMutation(\n  $input: DeleteChannelInput!\n) {\n  deleteChannel(input: $input) {\n    deletedId\n    deletedJoinedChannelId\n  }\n}\n"
  }
};
})();

node.hash = "0390384ee02b33b61242e9ab9f015b9e";

export default node;
